import { useToast } from "vuestic-ui"

export const successMessage = (message: string) => {
  const { init: notify } = useToast()
  const i18n = window.__I18N__
  const { t } = i18n
  notify({
    message: t(message),
    color: "success",
  })
}

export const errorMessage = (message: string, errorParameters?: any[]) => {
  const { init: notify } = useToast()
  const i18n = window.__I18N__
  const { t } = i18n
  notify({
    message:
      errorParameters && errorParameters.length > 0
        ? t(message, { [errorParameters[0]]: errorParameters[1] })
        : t(message),
    color: "danger",
  })
}

export const warningMessage = (message: string) => {
  const { init: notify } = useToast()
  const i18n = window.__I18N__
  const { t } = i18n
  notify({
    message: t(message),
    color: "warning",
  })
}

export const infoMessage = (message: string) => {
  const { init: notify } = useToast()
  const i18n = window.__I18N__
  const { t } = i18n
  notify({
    message: t(message),
    color: "info",
  })
}
